
import React from 'react'
// import styled from 'styled-components'

// import { FixedSpaceColumn } from 'lib-components/layout/flex-helpers'
import type { CitizenCustomizations } from 'lib-customizations/types'

import { citizenConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'
import mapConfig from './mapConfig'
import { H1, H2, P } from 'lib-components/typography'
import ExternalLink from 'lib-components/atoms/ExternalLink'
import colors from 'lib-customizations/common'

// const MultiLineCheckboxLabel = styled(FixedSpaceColumn).attrs({
//   spacing: 'zero'
// })`
//   margin-top: -6px;
// `

const customizations: CitizenCustomizations = {
  appConfig: citizenConfig,
  langs: ['fi', 'sv', 'en'],
  translations: {
    fi: {
      footer: {
        cityLabel: '© Kuhmon kaupunki',
        privacyPolicyLink: (
          <a
            href="https://www.kuhmo.fi/kaupunki-ja-paatoksenteko/asiointi/tietosuoja/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Tietosuojaselosteet
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.kuhmo.fi/kaupunki-ja-paatoksenteko/asiointi/osallistu-ja-vaikuta/anna-palautetta/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Lähetä palautetta
          </a>
        ),
      },
      loginPage: {
        title: 'Kuhmon kaupungin varhaiskasvatus',
        login: {
          infoBoxText: (
            <>
              <P>
                {/* If you are not able to log in here, see the instructions{' '}
                <a
                  href="https://www.espoo.fi/fi/palvelut/evaka"
                  target="_blank"
                  rel="noreferrer"
                >
                  eVaka | Kuhmon kaupunki
                </a>
                . You can also log in with strong authentication. */}
              </P>
            </>
          ),
        },
      },
      map: {
        privateUnitInfo: (
          <span>
            Tietoa päiväkodeista löydät{' '}
            <ExternalLink
              text="täältä."
              href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/paivakodit/"
              newTab
            />
          </span>
        ),
        mainInfo:
          "Tässä näkymässä voit hakea kartalta Kuhmon varhaiskasvatus-, esiopetus- ja kerhopaikkoja.",
      },
      applications: {
        creation: {
          preschoolInfo:
            'Maksutonta esiopetusta on neljä tuntia päivässä. Tämän lisäksi lapselle voidaan hakea maksullista täydentävää varhaiskasvatusta, jota tarjotaan esiopetuksessa aamulla klo 6.30 alkaen ennen esiopetuksen alkua ja iltapäivisin esiopetuksen jälkeen klo 17.30 asti. Hakemuksen täydentävään varhaiskasvatukseen voi tehdä esiopetukseen ilmoittautumisen yhteydessä tai erillisenä hakemuksena opetuksen jo alettua.',
          applicationInfo: (
            <P>
              Hakemukseen voi tehdä muutoksia niin kauan kuin hakemusta ei ole
              otettu käsittelyyn. Tämän jälkeen muutokset hakemukseen tehdään
              ottamalla yhteyttä varhaiskasvatuksen palveluohjaukseen (puh. 0447255317). Voit perua jo tehdyn hakemuksen ilmoittamalla siitä
              sähköpostilla varhaiskasvatuksen palveluohjaukseen{' '}
              <a href="mailto:vaka.asiakaspalvelu@kuhmo.fi">
                vaka.asiakaspalvelu@kuhmo.fi
              </a>
              .
            </P>
          ),
          transferApplicationInfo: {
            DAYCARE:
            "Lapsellasi on jo paikka Kuhmon kaupungin varhaiskasvatuksessa. Käytä tätä hakemusta hakeaksesi siirtoa toiseen varhaiskasvatusyksikköön.",
          },
        },
        editor: {
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    Varhaiskasvatusta voi hakea ympäri vuoden. Hakemus on jätettävä
                    viimeistään neljä kuukautta ennen kuin tarvitsette paikan.
                    Mikäli tarvitsette varhaiskasvatusta kiireellisesti työn tai
                    opiskelujen vuoksi, tulee paikkaa hakea viimeistään kaksi
                    viikkoa ennen.
                  </P>
                  <P>
                    Saat kirjallisen päätöksen varhaiskasvatuspaikasta{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P>
                    Kunnallisen varhaiskasvatuksen asiakasmaksut määräytyvät prosenttiosuutena
                    perheen bruttotuloista. Tulojen lisäksi maksuihin vaikuttaa perheen koko
                    ja sovittu varhaiskasvatusaika. Perhe toimittaa tuloselvityksen
                    bruttotuloistaan viimeistään kahden viikon kuluessa siitä, kun
                    lapsi on aloittanut varhaiskasvatuksessa.
                  </P>
                  <P>
                    Lisätietoa varhaiskasvatuksen maksuista ja tuloselvityksen
                    toimittamisesta löydät täältä:{' '}
                    <a href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/maksut/">
                      Maksut varhaiskasvatuksessa
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                    Esiopetukseen osallistutaan oppivelvollisuuden alkamista
                    edeltävänä vuonna. Esiopetus on maksutonta. Lukuvuoden 2026–2027
                    esiopetukseen ilmoittaudutaan 9.2.-22.2.2026.
                  </P>
                  <P>
                    Päätökset tulevat{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
            }
          },
          serviceNeed: {
            dailyTime: {
              connectedDaycareInfo: (
                <>
                  <P>
                    Voit hakea lapselle tarvittaessa{' '}
                    <strong>
                      esiopetukseen liittyvää varhaiskasvatusta, joka on
                      maksullista.
                    </strong>{' '}
                    Liittyvää varhaiskasvatusta järjestetään aamuisin ennen
                    esiopetusta ja esiopetuksen jälkeen esiopetusyksikön
                    aukioloaikojen mukaisesti.
                  </P>
                  <P>
                    Jos tarvitset varhaiskasvatusta ennen esiopetuksen alkua,
                    huomioi tämä toivotun aloituspäivämäärän valinnassa.
                  </P>
                  <P>
                    Saat varhaiskasvatuspaikasta erillisen kirjallisen päätöksen.
                    Päätös tulee{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi-viestit
                    -palvelua käyttöön.
                  </P>
                </>
              ),
            },
            shiftCare: {
              attachmentsMessage: {
                DAYCARE: (
                  <>
                    <P>
                      Vuorohoito on tarkoitettu lapsille, joiden molemmat
                      huoltajat ovat vuorotyössä tai opiskelevat pääsääntöisesti
                      iltaisin tai viikonloppuisin. Oikeus vuorohoitoon päättyy,
                      mikäli lapsi ei enää tarvitse vuorohoitoa huoltajan
                      työssäkäynnin tai opiskelun vuoksi, tällöin huoltajan
                      tulee hakea lapselleen uutta varhaiskasvatuspaikkaa.
                    </P>
                    <P>
                      Liitä hakemukseen työnantajan todistus säännöllisestä
                      vuorotyöstä tai oppilaitoksen edustajan todistus
                      päätoimisesta ilta- tai viikonloppuopiskelusta. Toimita
                      todistus molemmilta samassa taloudessa asuvilta
                      huoltajilta.
                    </P>
                    <P>
                      Jos et voi lisätä liitteitä hakemukselle sähköisesti,
                      lähetä ne postilla osoitteeseen Varhaiskasvatus, PL 15,
                      88901 Kuhmon kaupunki.
                    </P>
                  </>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      Vuorohoito on tarkoitettu lapsille, joiden molemmat
                      huoltajat ovat vuorotyössä tai opiskelevat pääsääntöisesti
                      iltaisin tai viikonloppuisin. Oikeus vuorohoitoon päättyy,
                      mikäli lapsi ei enää tarvitse vuorohoitoa huoltajan
                      työssäkäynnin tai opiskelun vuoksi.
                    </P>
                    <P>
                      Liitä hakemukseen työnantajan todistus säännöllisestä
                      vuorotyöstä tai oppilaitoksen edustajan todistus
                      päätoimisesta ilta- tai viikonloppuopiskelusta. Toimita
                      todistus molemmilta samassa taloudessa asuvilta
                      huoltajilta.
                    </P>
                    <P>
                      Jos et voi lisätä liitteitä hakemukselle sähköisesti,
                      lähetä ne postilla osoitteeseen Varhaiskasvatus, PL 15,
                      88901 Kuhmon kaupunki.
                    </P>
                  </>
                )
              },
            },
            partTime: {
              true: 'Osa-aikainen',
              false: 'Kokoaikainen'
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <>
                    <P fitted={true}>
                      Mikäli varhaiskasvatuspaikan tarve johtuu äkillisestä
                      työllistymisestä tai opiskelusta, tulee paikkaa hakea
                      viimeistään <strong>kaksi viikkoa ennen</strong> kuin tarve
                      alkaa. Hakemuksen{' '}
                      <strong>liitteenä tulee olla työ- tai opiskelutodistus</strong>{' '}
                      molemmilta samassa taloudessa asuvilta huoltajilta.
                      Suosittelemme toimittamaan liitteen sähköisesti tässä, sillä
                      kahden viikon käsittelyaika alkaa siitä, kun olemme
                      vastaanottaneet hakemuksen tarvittavine liitteineen. Jos et voi
                      lisätä liitteitä hakemukselle sähköisesti, lähetä ne postilla
                      osoitteeseen Varhaiskasvatus, PL 15, 88901
                      Kuhmon kaupunki.
                    </P>
                    <P>
                    <strong>Ilmoita haluttu varhaiskasvatuksen palvelutarve "Muut lisätiedot" -kohdassa ja valitse siihen jokin seuraavista:</strong>:
                    <ul>
                      <li>osa-aikainen, enintään 84 h/kk</li>
                      <li>osa-aikainen, enintään 150 h/kk</li>
                      <li>kokoaikainen, enintään 200 h/kk</li>
                    </ul>
                  </P>
                </>
                ),
              },
            },
            startDate: {
              info: {
                DAYCARE: [],
                PRESCHOOL: [
                  'Esiopetus alkaa 17.8.2026. Jos tarvitsette esioppilaalle täydentävää varhaiskasvatusta 1.8.2026 alkaen, voitte hakea sitä tällä hakemuksella valitsemalla "Haen esiopetuksen lisäksi täydentävää varhaiskasvatusta".'
                ],
                CLUB: [
                  'Kerhot noudattavat esiopetuksen työ- ja loma-aikoja. Kerhon toimintakausi on elokuusta toukokuun loppuun, ja kullekin toimintakaudelle haetaan erikseen. Eri kerhot kokoontuvat eri viikonpäivinä.'
                ]
              },
              instructions: {
                DAYCARE: (
                  <>
                    Toivottua aloituspäivää on mahdollista muuttaa myöhemmäksi niin
                    kauan kuin hakemusta ei ole otettu käsittelyyn. Tämän jälkeen
                    toivotun aloituspäivän muutokset tehdään ottamalla yhteyttä
                    varhaiskasvatuksen palveluohjaukseen (puh. 0447255317).
                  </>
                ),
                PRESCHOOL: (
                  <>
                    Toivottua aloituspäivää on mahdollista muuttaa myöhemmäksi niin
                    kauan kuin hakemusta ei ole otettu käsittelyyn. Tämän jälkeen
                    toivotun aloituspäivän muutokset tehdään ottamalla yhteyttä
                    varhaiskasvatuksen palveluohjaukseen (puh. 0447255317).
                  </>
                ),
                CLUB: null
              } as {
                DAYCARE: React.JSX.Element | null
                PRESCHOOL: React.JSX.Element | null
                CLUB: React.JSX.Element | null
              },
            },
          },
          contactInfo: {
            futureAddressInfo:
              "Kuhmon varhaiskasvatuksessa virallisena osoitteena pidetään väestötiedoista saatavaa osoitetta. Osoite väestötiedoissa muuttuu hakijan tehdessä muuttoilmoituksen postiin tai maistraattiin.",
          },
        },
      },
      accessibilityStatement: (
        <>
          <H1>Saavutettavuusseloste</H1>
          <P>
            Tämä saavutettavuusseloste koskee Kuhmon kaupungin varhaiskasvatuksen
            eVaka-verkkopalvelua osoitteessa{' '}
            <a href="https://varhaiskasvatus.kuhmo.fi">varhaiskasvatus.kuhmo.fi</a>.
            Kuhmon kaupunki pyrkii takaamaan verkkopalvelun saavutettavuuden,
            parantamaan käyttäjäkokemusta jatkuvasti ja soveltamaan asianmukaisia
            saavutettavuusstandardeja.
          </P>
          <P>
            Palvelun saavutettavuuden on arvioinut palvelun kehitystiimi, ja seloste
            on laadittu 12.4.2022.
          </P>
          <H2>Palvelun vaatimustenmukaisuus</H2>
          <P>
            Verkkopalvelu täyttää lain asettamat kriittiset
            saavutettavuusvaatimukset WCAG v2.1 -tason AA mukaisesti. Palvelu ei ole
            vielä kaikilta osin vaatimusten mukainen.
          </P>
          <H2>Toimet saavutettavuuden tukemiseksi</H2>
          <P>
            Verkkopalvelun saavutettavuus varmistetaan muun muassa seuraavilla
            toimenpiteillä:
          </P>
          <ul>
            <li>
              Saavutettavuus huomioidaan alusta lähtien suunnitteluvaiheessa, mm.
              valitsemalla palvelun värit ja kirjaisinten koot saavutettavasti.
            </li>
            <li>
              Palvelun elementit on määritelty semantiikaltaan johdonmukaisesti.
            </li>
            <li>Palvelua testataan jatkuvasti ruudunlukijalla.</li>
            <li>
              Erilaiset käyttäjät testaavat palvelua ja antavat saavutettavuudesta
              palautetta.
            </li>
            <li>
              Sivuston saavutettavuudesta huolehditaan jatkuvalla valvonnalla
              tekniikan tai sisällön muuttuessa.
            </li>
          </ul>
          <P>
            Tätä selostetta päivitetään sivuston muutosten ja saavutettavuuden
            tarkistusten yhteydessä.
          </P>
          <H2>Tunnetut saavutettavuusongelmat</H2>
          <P>
            Käyttäjät saattavat edelleen kohdata sivustolla joitakin ongelmia.
            Seuraavassa on kuvaus tunnetuista saavutettavuusongelmista. Jos huomaat
            sivustolla ongelman, joka ei ole luettelossa, otathan meihin yhteyttä.
          </P>
          <ul>
            <li>
              Palvelun päivämäärävalitsinta ja monivalintojen alasvetovalikkoa ei
              ole optimoitu käytettäväksi ruudunlukijalla.
            </li>
            <li>
              Palvelun yksikkökartassa ei pysty liikkumaan
              näppäimistöllä/ruudunlukijalla, mutta yksikköjä voi selata samassa
              näkymässä olevalta listalta. Palvelussa käytetty kartta on kolmannen
              osapuolen tuottama.
            </li>
          </ul>
          <H2>Kolmannet osapuolet</H2>
          <P>
            Verkkopalvelussa käytetään seuraavia kolmannen osapuolen palveluita,
            joiden saavutettavuudesta emme voi vastata.
          </P>
          <ul>
            <li>Keycloak käyttäjän tunnistautumispalvelu</li>
            <li>Suomi.fi-tunnistautuminen</li>
            <li>Leaflet-karttapalvelu</li>
          </ul>
          <H2>Anna palautetta</H2>
          <P>
            Jos huomaat saavutettavuuspuutteen verkkopalvelussamme, kerro siitä
            meille. Voit antaa palautetta{' '}
            <ExternalLink
              href="https://www.kuhmo.fi/kaupunki-ja-paatoksenteko/asiointi/osallistu-ja-vaikuta/anna-palautetta/"
              text="verkkolomakkeella"
            />{' '}
            tai sähköpostitse{' '}
            <a href="mailto:kirjaamo@kuhmo.fi">kirjaamo@kuhmo.fi</a>.
          </P>
          <H2>Valvontaviranomainen</H2>
          <P>
            Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta
            meille sivuston ylläpitäjille. Vastauksessa voi mennä 14 päivää. Jos et
            ole tyytyväinen saamaasi vastaukseen, tai et saa vastausta lainkaan
            kahden viikon aikana, voit antaa palautteen Etelä-Suomen
            aluehallintovirastoon. Etelä-Suomen aluehallintoviraston sivulla
            kerrotaan tarkasti, miten valituksen voi tehdä, ja miten asia
            käsitellään.
          </P>
          <P>
            <strong>Valvontaviranomaisen yhteystiedot </strong>
            <br />
            Etelä-Suomen aluehallintovirasto <br />
            Saavutettavuuden valvonnan yksikkö
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            puhelinnumero vaihde 0295 016 000
            <br />
            Avoinna: ma-pe klo 8.00–16.15
          </P>
        </>
      ),
      income: {
        description: (
          <>
            <P>
              Tällä sivulla voit lähettää selvitykset varhaiskasvatusmaksuun
              vaikuttavista omista ja lastesi tuloista. Voit myös tarkastella
              palauttamiasi tuloselvityksiä ja muokata tai poistaa niitä, kunnes
              viranomainen on käsitellyt tiedot. Lomakkeen käsittelyn jälkeen voit
              päivittää tulotietojasi toimittamalla uuden lomakkeen.
            </P>

            <P>
              Kunnallisen varhaiskasvatuksen asiakasmaksut määräytyvät
              prosenttiosuutena perheen bruttotuloista. Maksut vaihtelevat perheen
              koon ja tulojen sekä varhaiskasvatusajan mukaan. Tarkista
              asiakastiedotteen taulukosta (jonka löydät{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/maksut/"
              >
                täältä
              </a>
              ) tarvitseeko sinun toimittaa tuloselvitystä, vai kuuluuko perheenne
              automaattisesti korkeimman varhaiskasvatusmaksun piiriin.
            </P>
            <P>
              Lisätietoja maksuista:{' '}
              <a href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/maksut/">
                Maksut varhaiskasvatuksessa
              </a>
            </P>
            <strong>Tärkeää</strong>
            <ul>
              <li>
                Maksu määräytyy kaikkien samassa osoitteessa asuvien aikuisten
                tulojen perusteella. Sinun ja mahdollisen samassa osoitteessa asuvan
                puolisosi on ilmoitettava tulonne erikseen.
              </li>
            </ul>
          </>
        ),
        view: {
          incomesRegister:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan Kelasta.',
          checkupConsent:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa Kelasta.',
          limitedCompanyIncomesRegister:
            'Tuloni voi tarkastaa suoraan Kelasta tarvittaessa.',
          noIncomeTitle:
            'Minulla ei ole mitään tuloja tai tukia. Tietoni saa tarkastaa Kelasta.',
        },
        limitedCompany: {
          incomesRegister:
            'Tuloni voi tarkastaa tarvittaessa Kelasta.',
        },
        entrepreneurIncome: {
          checkupConsent:
          'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa Kelasta.',
        },
        grossIncome: {
          description: (
            <>
              <P noMargin>
                Valitse alta haluatko toimittaa tulotietosi liitteinä, vai katsooko
                viranomainen tietosi suoraan Kelasta
                tarvittaessa.
              </P>
              <P>
                Jos olet aloittanut tai aloittamassa uudessa työssä, lähetä aina
                liitteenä työsopimus, josta ilmenee palkka.
              </P>
            </>
          ),
          incomesRegisterConsent:
          'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan Kelasta tarvittaessa',
           noIncome:
          'Minulla ei ole mitään tuloja tai tukia. Tietoni saa tarkastaa Kelasta.',
        },
      },
    },
    sv: {},
    en: {
      income: {
        title: 'Income information',
        description: (
          <>
            <P>
              On this page, you can submit statements on your and your
              children's earnings that affect the early childhood education
              fee. You can also view, edit, or delete income statements that you
              have submitted until the authority has processed the information.
              After the form has been processed, you can update your income
              information by submitting a new form.
            </P>
            <P>
              The client fees for municipal early childhood education are determined
              as a percentage of the family’s gross income. The fees vary according
              to family size, income and time in early childhood education. Check
              the table in the customer bulletin (found{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/maksut/"
              >
                here
              </a>
              ) to see if you need to submit an income statement or if your family
              belongs to the category of the highest early childhood education fee.
            </P>
            <P>
              More information on the fees:{' '}
              <a href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/maksut/">
                Early childhood education fees
              </a>
            </P>
            <strong>Important</strong>
            <ul>
              <li>
                The fee is determined based on the income of all adults living at
                the same address. You and your possible spouse living at the same
                address must both declare your income separately.
              </li>
            </ul>
          </>
        ),
      },
      footer: {
        cityLabel: '© City of Kuhmo',
        privacyPolicyLink: (
          <a
            href="https://www.kuhmo.fi/kaupunki-ja-paatoksenteko/asiointi/tietosuoja/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Privacy notices
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://www.kuhmo.fi/kaupunki-ja-paatoksenteko/asiointi/osallistu-ja-vaikuta/anna-palautetta/"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Give feedback
          </a>
        ),
      },
      loginPage: {
        title: 'City of Kuhmo early childhood education',
        login: {
          infoBoxText: (
            <>
              <P>
                {/* If you are not able to log in here, see the instructions{' '}
                <a
                  href="https://www.espoo.fi/fi/palvelut/evaka"
                  target="_blank"
                  rel="noreferrer"
                >
                  eVaka | Kuhmon kaupunki
                </a>
                . You can also log in with strong authentication. */}
              </P>
            </>
          ),
        },
      },
      map: {
        privateUnitInfo: (
          <span>
            More information of daycares{' '}
            <ExternalLink
              text="here."
              href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/paivakodit/"
              newTab
            />
          </span>
        ),
        mainInfo:
          "In this view, you can search the map for Kuhmo's early childhood education, pre-primary education and club places.",
      },
      applications: {
        creation: {
          transferApplicationInfo: {
            DAYCARE:
              "Your child already has a place in the City of Kuhmo's early childhood education. Use this application to apply for a transfer to another early childhood education unit.",
          },
        },
        editor: {
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    You can apply for early childhood education throughout the year.
                    The application must be submitted at least four months before you need the place.
                    If you need early childhood education urgently due to work or studies, the place
                    must be applied for at least two weeks in advance.
                  </P>
                  <P>
                    You will receive a written decision about the early childhood education place{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi messages
                    </a>{' '}
                    service or by mail if you have not activated the Suomi.fi
                    service.
                  </P>
                  <P>
                    Municipal early childhood education fees are determined as a percentage
                    of the family's gross income. In addition to income, the fees are influenced
                    by the family's size and the agreed early childhood education time. The family
                    must provide a statement of their gross income no later than two weeks after the
                    child has started early childhood education.
                  </P>
                  <P>
                    For more information on early childhood education fees, submitting income statements, and additional service voucher fees, see here:{' '}
                    <a href="https://www.kuhmo.fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus/maksut/">
                      Early childhood education fees
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Fields marked with an asterisk are mandatory</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                    Preschool is attended in the year preceding the start of compulsory education.
                    Preschool is free of charge. Registration for the 2026–2027 school year takes
                    place from 9.2.-22.2.2026. Preschool starts on 17.8.2026.
                  </P>
                  <P>
                    Decisions will be sent to the{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi messages
                    </a>{' '}
                    service or by mail if you have not activated the Suomi.fi
                    service.
                  </P>
                  <P fitted={true}>* Fields marked with an asterisk are mandatory</P>
                </>
              ),
            }
          },
          serviceNeed: {
            dailyTime: {
              label: {
                DAYCARE: 'Daily early childhood education time',
                PRESCHOOL:
                  'Early childhood education need related to pre-primary education'
              },
              connectedDaycareInfo: (
                <>
                  <P>
                    You can apply for your child early childhood education related
                    to pre-primary education, which is subject to a charge. Related
                    early childhood education is provided in the mornings before
                    pre-primary education and in the afternoons after pre-primary
                    education in accordance with the opening hours of the
                    pre-primary education unit.
                  </P>
                  <P>
                    If your child needs early childhood education before pre-primary
                    education starts, please take this into account when selecting
                    the desired starting date.
                  </P>
                  <P>
                    A separate written decision will be issued on the early
                    childhood education place. The decision will be sent to the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service or by post if you do not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi messages
                    </a>{' '}
                    service.
                  </P>
                </>
              ),
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <>
                    <P fitted={true}>
                      If the need for an early childhood education place is due to sudden employment
                      or studies, the place must be applied for at least <strong>two weeks before</strong>
                      the need begins. The application must include a <strong>work or study certificate</strong>
                      from both guardians living in the same household.We recommend submitting the attachment
                      electronically here, as the two-week processing time starts from the moment we have
                      received the application with the necessary attachments. If you cannot add attachments
                      to the application electronically, send them by mail to Varhaiskasvatus, PL 15, 88901 Kuhmon kaupunki.
                    </P>
                </>
                ),
              },
            },
            startDate: {
              info: {
                DAYCARE: [],
                PRESCHOOL: [
                  'Preschool starts on 17.8.2026. If you need additional early childhood education for your preschooler starting from 1.8.2026, you can apply for it with this application by selecting "I am applying for additional early childhood education in addition to preschool".'
                ],
                CLUB: [
                  'Clubs follow the working and holiday times of preschool. The club season is from August to the end of May, and each season must be applied for separately. Different clubs meet on different days of the week.'
                ]
              },
              instructions: {
                DAYCARE: (
                  <>
                    You can change the start date to a later date as long as the application has not been processed.
                    After that, changes to the desired start date can be made by contacting
                    early childhood education service guidance (tel. 0447255317).
                  </>
                ),
                PRESCHOOL: (
                  <>
                    You can change the start date to a later date as long as the application has not been processed.
                    After that, changes to the desired start date can be made by contacting
                    early childhood education service guidance (tel. 0447255317).
                  </>
                ),
                CLUB: null
              } as {
                DAYCARE: React.JSX.Element | null
                PRESCHOOL: React.JSX.Element | null
                CLUB: React.JSX.Element | null
              },
            },
            shiftCare: {
              label: 'Evening and round-the-clock care',
              instructions:
                'Round-the-clock care refers to early childhood education needed on weekends or around the clock. Evening and round-the-clock care is mainly early childhood education taking place outside the weekday hours of 6:30 and 17:30.',
              attachmentsMessage: {
                DAYCARE: (
                  <P>
                    Evening and round-the-clock care is intended for children whose
                    both parents do shift work or mainly study in the evening and/or
                    during the weekends. In addition to the application, both
                    parents will need to provide a document issued by their employer
                    concerning shift work or a document concerning their studies as
                    proof of the child’s need for evening or round-the-clock care.
                    We recommend that you send the additional documents through this
                    online system. If you are unable to add attachments to your
                    online application, please send the documents by post to
                    Varhaiskasvatus, PL 15, 88901 City of Kuhmo.
                  </P>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      If a guardian living in the same household does regular shift
                      work or attends evening studies full-time, they must provide
                      proof of this (a document issued by their employer or the
                      educational institution) together with the application for
                      pre-primary education. The documents must be dated in the year
                      when the application for pre-primary education is submitted.
                    </P>
                    <P>
                      Evening and round-the-clock care is intended for children
                      whose both parents do shift work or mainly study in the
                      evening and/or during the weekends. In addition to the
                      application, both parents will need to provide a document
                      issued by their employer concerning shift work or a document
                      concerning their studies as proof of the child’s need for
                      evening or round-the-clock care. We recommend that you send
                      the additional documents through this online system. If you
                      are unable to add attachments to your online application,
                      please send the documents by post to Varhaiskasvatus, PL 15,
                      88901 City of Kuhmo.
                    </P>
                  </>
                )
              },
              attachmentsSubtitle:
                'Add here, for both parents, either a document issued by their employer concerning shift work or a document concerning their evening/weekend studies.'
            },
          },
          contactInfo: {
            futureAddressInfo:
              "Kuhmo's early childhood education considers the address retrieved from the Population Register Centre as the official address. The address in the Population Register Centre changes when the applicant makes a notification of move to Posti or the Local Register Office.",
          },
        },
      },
      accessibilityStatement: (
        <>
          <H1>Accessibility statement</H1>
          <P>
            This accessibility statement applies to the City of Kuhmo's early
            childhood education online service eVaka at{' '}
            <a href="https://varhaiskasvatus.kuhmo.fi">varhaiskasvatus.kuhmo.fi</a>.
            The City of Kuhmo endeavours to ensure the accessibility of the online
            service, continuously improve the user experience and apply appropriate
            accessibility standards.
          </P>
          <P>
            The accessibility of the service was assessed by the development team of
            the service, and this statement was drawn up on 12 April 2022.
          </P>
          <H2>Compliance of the service</H2>
          <P>
            The online service complies with the statutory critical accessibility
            requirements in accordance with Level AA of the Accessibility Guidelines
            for the WCAG v2.1. The service is not yet fully compliant with the
            requirements.
          </P>
          <H2>Measures to support accessibility</H2>
          <P>
            The accessibility of the online service is ensured, among other things,
            by the following measures:
          </P>
          <ul>
            <li>
              Accessibility has been taken into account from the beginning of the
              design phase, for example, when choosing the colours and font sizes of
              the service.
            </li>
            <li>
              The service elements have been defined in consistently in terms of
              semantics.
            </li>
            <li>The service is continuously tested with a screen reader.</li>
            <li>
              Various users test the service and give feedback on its accessibility.
            </li>
            <li>
              When website technology or content changes, its accessibility is
              ensured through constant monitoring.
            </li>
          </ul>
          <P>
            This statement will be updated in conjunction with website changes and
            accessibility evaluations.
          </P>
          <H2>Known accessibility issues</H2>
          <P>
            Users may still encounter some issues on the website. The following
            contains a description of known accessibility issues. If you notice an
            issue on the site that is not listed, please contact us.
          </P>
          <ul>
            <li>
              Date pickers and multi-select dropdowns in the service are not
              optimised to be used with a screen reader.
            </li>
            <li>
              The service's unit map cannot be navigated using the keyboard/screen
              reader, but the units can be browsed on the list available in the same
              view. The map used in the service is produced by a third party.
            </li>
          </ul>
          <H2>Third parties</H2>
          <P>
            The online service uses the following third party services, the
            accessibility of which we cannot be responsible for.
          </P>
          <ul>
            <li>Keycloak user identification service</li>
            <li>Suomi.fi identification</li>
            <li>Leaflet map service</li>
          </ul>
          <H2>Give feedback</H2>
          <P>
            If you notice an accessibility gap in our online service, please let us
            know! You can give us feedback using the{' '}
            <ExternalLink
              href="https://www.kuhmo.fi/kaupunki-ja-paatoksenteko/asiointi/osallistu-ja-vaikuta/anna-palautetta/"
              text="online form"
            />{' '}
            or by emailing{' '}
            <a href="mailto:kirjaamo@kuhmo.fi">kirjaamo@kuhmo.fi</a>.
          </P>
          <H2>Supervisory authority</H2>
          <P>
            If you notice any accessibility issues on the website, please send us,
            the site administrator, feedback first. It may take us up to 14 days to
            reply. If you are not satisfied with the reply or you do not receive a
            reply within two weeks, you can give feedback to the Regional State
            Administrative Agency for Southern Finland. The website of the Regional
            State Administrative Agency for Southern Finland explains in detail how
            a complaint can be submitted, and how the matter will be processed.
          </P>
          <P>
            <strong>Contact information of the supervisory authority</strong>
            <br />
            Regional State Administrative Agency of Southern Finland
            <br />
            Accessibility Supervision Unit
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            tel. (exchange) 0295 016 000
            <br />
            Open: Mon-Fri 8.00–16.15
          </P>
        </>
      ),
    },
  },
  cityLogo: {
    src: MunicipalityLogo,
    alt: 'Kuhmo logo',
  },
  routeLinkRootUrl: 'https://reittiopas.hsl.fi/reitti/',
  mapConfig,
  featureFlags,
  getMaxPreferredUnits() {
    return 3
  },
}

export default customizations
